"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalanceRequest = void 0;
var AccountBalanceRequest = /** @class */ (function () {
    function AccountBalanceRequest() {
    }
    return AccountBalanceRequest;
}());
exports.AccountBalanceRequest = AccountBalanceRequest;
;
//# sourceMappingURL=accountBalance.request.js.map